"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFinancialStatementPeriodPartitionedTable = exports.isCreditFacilitySlugReportingDateFileVersionPartitionedTable = exports.isNamedRDFVPartitionedTable = exports.isReportingDateFileVersionPartitionedTable = exports.isCustomTapeTable = exports.isLatestTable = exports.OptionalColumnsForInsightsQueries = exports.DATALAKE_ERRORS = exports.containsNestedArray = exports.transformToDatalakeBuffer = exports.generateStandardTransformationOps = exports.athena = void 0;
const lodash = __importStar(require("lodash"));
const finley_types_1 = require("@finley-technologies/finley-types");
const { forEach, isArray, isObjectLike, some, values } = lodash;
exports.athena = __importStar(require("./athena.utils"));
/**
 * We encode aws glue transformation ops in s3Path when writing to raw bucket.
 *
 * Transformation operations executed nested order (akin to a stack data structure)
 * OpC(OpB(OpA(DATA_STRUCTURE)))
 *
 * AWS Glue Code in `infra/source/datalake/glue-job/transform.py` is responsible for executing these transformation ops
 */
const generateStandardTransformationOps = () => [
    finley_types_1.DataLake.TransformationOp.WriteParquetToCurated,
    finley_types_1.DataLake.TransformationOp.AttachMetadata,
    finley_types_1.DataLake.TransformationOp.ShortenColumnNames,
    finley_types_1.DataLake.TransformationOp.Unnest,
    finley_types_1.DataLake.TransformationOp.CastNumberFieldsAsDouble,
    finley_types_1.DataLake.TransformationOp.ResolveChoice,
];
exports.generateStandardTransformationOps = generateStandardTransformationOps;
const transformToDatalakeBuffer = (payload) => {
    if (isArray(payload)) {
        const buffers = [];
        forEach(payload, (el) => {
            const str = `${JSON.stringify(el)}\n`;
            buffers.push(Buffer.from(str));
        });
        return Buffer.concat(buffers);
    }
    // NOTE: we are unlikely to have an issue anytime soon with single POJO
    // exceeding Node string length limitation, but we can use
    // big-json.createStringifyStream to stream json to buffer
    // https://www.npmjs.com/package/big-json
    return Buffer.from(`${JSON.stringify(payload)}\n`);
};
exports.transformToDatalakeBuffer = transformToDatalakeBuffer;
const containsNestedArray = (payload) => {
    const containsArray = (pl) => {
        if (isArray(pl))
            return true;
        if (!isObjectLike(pl))
            return false;
        return some(values(pl), (val) => containsArray(val));
    };
    // a payload that contains an array at the root is acceptable (and most common) for datalake payloads
    if (isArray(payload)) {
        return some(payload, containsArray);
    }
    return containsArray(payload);
};
exports.containsNestedArray = containsNestedArray;
// ************************************************
//                  ERROR HANDLING
// ************************************************
exports.DATALAKE_ERRORS = {
    TableNotFound: 'TABLE_NOT_FOUND',
    ColumnNotFound: 'COLUMN_NOT_FOUND',
};
/**
 * This list contains a subset of columns that are required for
 * certain insights queries but do not necessarily exist in every entity's tables.
 *
 * The list below should contain only the columns where we are comfortable with
 * NOT logging their absence as an Error. As such, do not include any columns
 * that are actually vital to basic queries, since we do want to loudly flag
 * those being missing.
 *
 * Since these will be WARN level logs, we will not be able to easily detect
 * when a customer should actually have these set up
 * (eg. rif formulas in the CA). Therefore it is extra important to be vigilant
 * during customer implementation to set up these fields if they should be available.
 */
exports.OptionalColumnsForInsightsQueries = [
    // the below "required" intermediate fields are actually not required in the
    // CA configuration, because some customers will not have these concepts
    'rif.normalizeddayspastdue',
    'rif.normalizeddurationdays',
    'rif.normalizedischargedoff',
    'rif.normalizedisdelinquent',
    'rif.normalizedoriginationdate',
    'rif.normalizedinitialbalance',
    'totalperformingexposure', // this is calculated from charge offs & delinquencies, so if those rifs don't exist, this column will not exist either
];
const isLatestTable = (tableName) => {
    return !!tableName.match(/^.+_latest_.+$/);
};
exports.isLatestTable = isLatestTable;
const isCustomTapeTable = (tableName) => {
    return finley_types_1.DataLake.CUSTOM_TAPES_PREFIXES.some((prefix) => tableName.startsWith(prefix));
};
exports.isCustomTapeTable = isCustomTapeTable;
const isReportingDateFileVersionPartitionedTable = (tableName) => {
    return finley_types_1.DataLake.REPORTING_DATE_FILE_VERSION_PARTITION_TABLES.some((prefix) => tableName.startsWith(prefix));
};
exports.isReportingDateFileVersionPartitionedTable = isReportingDateFileVersionPartitionedTable;
const isNamedRDFVPartitionedTable = (tableName) => {
    return finley_types_1.DataLake.NAMED_RDFV_PARTITION_TABLES.some((prefix) => tableName.startsWith(prefix));
};
exports.isNamedRDFVPartitionedTable = isNamedRDFVPartitionedTable;
const isCreditFacilitySlugReportingDateFileVersionPartitionedTable = (tableName) => {
    return finley_types_1.DataLake.LIMITED_PARTNERS_ENTITY_CREDIT_FACILITY_SLUG_PARTITION_TABLES.some((prefix) => tableName.startsWith(prefix));
};
exports.isCreditFacilitySlugReportingDateFileVersionPartitionedTable = isCreditFacilitySlugReportingDateFileVersionPartitionedTable;
const isFinancialStatementPeriodPartitionedTable = (tableName) => {
    return finley_types_1.DataLake.FINANCIAL_STATEMENT_ENTITY_PERIOD_DATALAKE_TABLE_NAME.some((prefix) => tableName.startsWith(prefix));
};
exports.isFinancialStatementPeriodPartitionedTable = isFinancialStatementPeriodPartitionedTable;
//# sourceMappingURL=index.js.map